/**
 * DevExtreme (esm/__internal/scheduler/header/constants.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var Direction;
!function (Direction) {
  Direction[Direction.Left = -1] = "Left";
  Direction[Direction.Right = 1] = "Right";
}(Direction || (Direction = {}));